import _arrayWithoutHoles from './arrayWithoutHoles.js';
import _iterableToArray from './iterableToArray.js';
import _unsupportedIterableToArray from './unsupportedIterableToArray.js';
import _nonIterableSpread from './nonIterableSpread.js';

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

export { _toConsumableArray as default };
